export default (state, getter) => val => {
    let requests = getter.requests(val);
    return Math.round(requests.reduce(function (sum, current) {
        return sum + current.sum;
    }, 0) * 100) / 100;
}